export const loginValidationRules = {
  email: {
    required: true,
    pattern: /\S+@\S+\.\S+/,
    message: {
      required: "Email is required",
      pattern: "Please enter a valid email address"
    }
  },
  password: {
    required: true,
    minLength: 8,
    message: {
      required: "Password is required",
      minLength: "Password must be at least 8 characters long"
    }
  }
};

export function validateForm(values, rules) {
  const errors = {};

  Object.keys(rules).forEach(field => {
    const value = values[field];
    const rule = rules[field];

    // Check required
    if (rule.required && !value) {
      errors[field] = rule.message.required;
      return;
    }

    // Check pattern (for email)
    if (rule.pattern && value && !rule.pattern.test(value)) {
      errors[field] = rule.message.pattern;
      return;
    }

    // Check minLength (for password)
    if (rule.minLength && value && value.length < rule.minLength) {
      errors[field] = rule.message.minLength;
    }
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
}

export const passwordValidationRules = {
  pattern: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
  message: {
      pattern: "Password must contain at least 8 characters, one uppercase letter, one number, and one special character",
      match: "Confirm Password does not match",
      required: "Password is required"
  }
};

export const validatePassword = (password, confirmPassword) => {
  const errors = {};

  if (!password) {
      errors.password = passwordValidationRules.message.required;
  } else if (!passwordValidationRules.pattern.test(password)) {
      errors.password = passwordValidationRules.message.pattern;
  }

  if (!confirmPassword) {
      errors.confirmPassword = "Confirm password is required";
  } else if (password !== confirmPassword) {
      errors.confirmPassword = passwordValidationRules.message.match;
  }

  return {
      isValid: Object.keys(errors).length === 0,
      errors
  };
};

class ValidationHandler {
  static validateForm(data, rules) {
      const errors = {};

      Object.keys(rules).forEach(field => {
          const value = data[field];
          const rule = rules[field];

          if (rule.required && !value) {
              errors[field] = rule.message || `${field} is required`;
              return;
          }

          if (value && rule.pattern && !rule.pattern.test(value)) {
              errors[field] = rule.message || `${field} is invalid`;
              return;
          }

          if (rule.match && value !== data[rule.match]) {
              errors[field] = rule.message || `${field} does not match`;
              return;
          }
      });

      return errors;
  }
}

export default ValidationHandler;